import React, { FC, useRef } from 'react'
import { AnimationWrapper } from '@elements/Animation/styles'

export enum AnimationType {
  fade = 'fade',
}

export interface AnimationProps {
  duration?: number
  delay?: number
  type?: AnimationType
}

const Animation: FC<AnimationProps> = ({
  duration = 300,
  delay = 0,
  children,
  type = AnimationType.fade,
  ...delegated
}) => {
  const renderCount = useRef(0)
  renderCount.current = renderCount.current + 1
  return (
    <AnimationWrapper
      {...delegated}
      key={`animation_${renderCount.current}`}
      data-testid={'animation-wrapper'}
      style={{
        animationDuration: duration + 'ms',
        animationDelay: delay + 'ms',
      }}
      type={type}
    >
      {children}
    </AnimationWrapper>
  )
}

export default Animation
